<form [formGroup]="searchForm">
  <div>
    <mat-form-field>
      <mat-label>{{ title || "input-model" | translate }}</mat-label>
      <input
        type="text"
        matInput
        [matAutocomplete]="autoComplete"
        formControlName="name"
      />
      <mat-autocomplete autoActiveFirstOption #autoComplete="matAutocomplete">
        <mat-option disabled class="loading" *ngIf="loading">
          <mat-spinner diameter="25"></mat-spinner>
        </mat-option>
        <mat-option
          *ngFor="let model of models"
          (onSelectionChange)="handleVehicleModelChange($event, model)"
          [value]="model.displayName"
          class="autocomplete"
        >
          {{ model.displayName }}
        </mat-option>
      </mat-autocomplete>
      <mat-error
        translate
        *ngIf="this.searchForm.controls.name.touched && !this.searchForm.valid"
        >{{ requiredText || "required-model" | translate }}</mat-error
      >
    </mat-form-field>
  </div>
</form>
